import { ICaptchaInfo } from "@commonRendering/types";

export class FormCaptchaRenderer {

    public render(element: HTMLElement, data: ICaptchaInfo): void {
        const form = element.querySelector("form");
        if (!form) {
            return;
        }

        switch (data.captchaProtectionType) {
            case "TruCaptcha":
                this.addTruCaptchaClass(form);
                break;
            case "ReCaptcha":
                this.addRecaptchaData(form, data);
                break;
            default:
                break;
        }
    }

    public addTruCaptchaClass(form: HTMLFormElement): void {
        form.classList.add("with-tru-captcha");
    }

    public addRecaptchaData(form: HTMLFormElement, data: ICaptchaInfo): void {
        form.dataset.settings = data.reCaptchaSettingBase64;
    }

}
